'use client'

import { cn } from '@/lib/utils'
import { ReactNode, useEffect, useRef } from 'react'

const EDGE_TOLERANCE = 1

/**
 * Khung cuộn dọc của gallery (desktop). Trình duyệt "latch" cả chuỗi wheel/trackpad
 * vào khung cuộn bên trong nên khi đã cuộn hết ảnh, trang không cuộn tiếp.
 * Khi đã chạm đáy/đỉnh theo hướng cuộn → chuyển delta sang window để trang cuộn tiếp.
 */
export const ProductGalleryScrollArea = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const onWheel = (e: WheelEvent) => {
      if (e.ctrlKey || e.deltaY === 0) return
      // Cuộn ngang (trackpad) để embla/browser tự xử lý
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return
      // Khung không cuộn được (mobile / nội dung ngắn) → để mặc định
      if (el.scrollHeight - el.clientHeight <= EDGE_TOLERANCE) return

      const atTop = el.scrollTop <= EDGE_TOLERANCE
      const atBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - EDGE_TOLERANCE

      if ((e.deltaY > 0 && atBottom) || (e.deltaY < 0 && atTop)) {
        const delta =
          e.deltaMode === 1
            ? e.deltaY * 16
            : e.deltaMode === 2
              ? e.deltaY * window.innerHeight
              : e.deltaY
        e.preventDefault()
        window.scrollBy({ top: delta, behavior: 'instant' })
      }
    }

    el.addEventListener('wheel', onWheel, { passive: false })
    return () => el.removeEventListener('wheel', onWheel)
  }, [])

  return (
    <div ref={ref} className={cn(className)}>
      {children}
    </div>
  )
}
